<template>
  <div class="fullScreen">
    <app-header></app-header>
    <div class="main_box">
      <router-view></router-view>
    </div>
    <app-footer></app-footer>
    <!--<app-footer v-show="show"></app-footer>-->
  </div>
</template>

<script>
  export default {
    name: "Main",
    /*computed: {
      show() {
        return this.$route.meta.requiresAuth;
      },
    },*/
    components: {
      "app-header": () => import("@/components/LayOut/Common/Header"),
      "app-footer": () => import("@/components/LayOut/Common/Footer")
    },
  }
</script>

<style lang="stylus" scoped>
  .fullScreen {
    width: 100%;
    height: 100%;
    .main_box {
      width: 100%;
      height: calc(100% - 150px);
    }
  }
</style>